import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api'; // adjust if your axios instance is elsewhere


// Thunk for adding a new business
export const addBusiness = createAsyncThunk(
    'businesses/addBusiness',
    async ({ business_name, email }, { rejectWithValue }) => {
      try {
        const response = await api.post('/businesses', {
          business_name,
          email
        });
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.statusText || error.message);
      }
    }
  );

const businessesSlice = createSlice({
    name: 'businesses',
    initialState: {
        items: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
        // handle addBusiness
        .addCase(addBusiness.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(addBusiness.fulfilled, (state, action) => {
            state.loading = false;
            state.items = action.payload; // set the fetched users
            
        })
        .addCase(addBusiness.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
    });

    export default businessesSlice.reducer;
